module.exports = __webpack_public_path__ + "static/media/BPS_0482.870f9f8e.jpg";